document.addEventListener('alpine:init', () => {
  Alpine.store('cart', {
    cart: window.sideCart.cart,
    items: []
  });

  Alpine.data('sidecart', () => ({
    isOpen: false,
    loading: false,
    cartSellingPlans: {},
    freeGiftThreshold: window.sideCart.settings.freeGiftThreshold,
    freeGiftVariants: window.sideCart.settings.freeGiftVariants || [],
    
    init() {
      this.fetchSellingPlans();

      if (PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
          this.open();
        });
      }

      // Listen for cart updates
      window.addEventListener('cart:updated', (event) => {
          this.$store.cart.cart = event.detail.cart;
          this.$store.cart.items = event.detail.cart.items;
          this.fetchSellingPlans();
      });

      window.addEventListener('cart:refresh', (event) => {
        this.fetchCart();
      });
      
      
      // Listen for cart open events
      window.addEventListener('cart:open', () => {
        this.open();
      });
      
      // Add click listener for cart icon in header
      this.setupCartIconListener();
    },

    get cartItems(){
      let items = this.$store.cart.cart.items;

      if (items) {
        items.forEach(item => {
          const sellingPlans = this.cartSellingPlans[item.key];
          if (sellingPlans) {
            item.selling_plans = sellingPlans;
          }
        });
      }

      return items || [];
    },

    get totalSamplesInCart(){
      const freeSamples = window.freeSampleProducts || [];
      const cartItems = this.$store.cart.cart.items || [];
      return cartItems.reduce((total, item) => {
      const isSample = freeSamples.some(product => {
        const sampleVariantId = product.variants && product.variants[0] ? product.variants[0].id : product.id;
        return item.variant_id === sampleVariantId || item.product_id === product.id;
      });
      return isSample ? total + item.quantity : total;
      }, 0);
    },

    get remainingToFreeGift(){
      return this.formatMoney(this.freeGiftThreshold - this.$store.cart.cart.total_price);
    },

    get isFreeGiftEligible(){
      return this.$store.cart.cart.total_price >= this.freeGiftThreshold;
    },

    get isFreeGiftInCart(){
      const result = this.$store.cart.cart.items.some((item) => {
        console.log('DEBUG: widget', item.properties, item.properties && item.properties?._widget === 'cart9202689gqp');
        return item.properties && item.properties?._widget === 'cart9202689gqp';
      });

      console.log('DEBUG: isFreeGiftInCart', result);
      return result;
    },

    get isFreeGiftManuallyRemoved(){
      return this.$store.cart.cart.attributes && 
             this.$store.cart.cart.attributes.free_gift_removed === 'true';
    },

    // New method to select a specific free gift
    async selectFreeGift(variantId) {
      // First, remove any existing free gift
      const existingFreeGift = this.$store.cart.cart.items.find(item => 
        item.properties && item.properties._widget === 'cart9202689gqp'
      );
      
      if (existingFreeGift) {
        await this.removeItem(existingFreeGift.key);
      }
      
      // Add the selected free gift
      await this.addToCart(variantId, {'_widget': 'cart9202689gqp'});
    },

    captureSellingPlans(){
      const jsonScript = document.querySelector('#cart-selling-plans-data');
      const data = JSON.parse(jsonScript.textContent);
      this.cartSellingPlans = data;
    },
    
    setupCartIconListener() {
      // Wait for DOM to be fully loaded
      document.addEventListener('DOMContentLoaded', () => {
        const cartIcons = document.querySelectorAll('.header__icon--cart, .header__icon.header__icon--cart');
        
        cartIcons.forEach(icon => {
          icon.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.open();
          });
        });
      });
    },
    
    open() {
      document.body.classList.add('rh-sidecart-open');
      this.fetchCart();
      // Set isOpen after a tiny delay to ensure CSS transitions work properly
      setTimeout(() => {
        this.isOpen = true;
      }, 10);
    },
    
    close() {
      this.isOpen = false;
      setTimeout(() => {
        document.body.classList.remove('rh-sidecart-open');
      }, 300); // Match the transition duration
    },
    
    async fetchCart() {
      this.loading = true;
      try {
        // Use the cart-data section to get full cart data with properties
        const response = await fetch('/?section_id=cart-data');
        const html = await response.text();
        
        // Parse the HTML to extract cart data
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        const cartDataScript = tempDiv.querySelector('#cart-data');
        if (cartDataScript) {
          const cartData = JSON.parse(cartDataScript.textContent);
          console.log('DEBUG: cart data', cartData);
          this.$store.cart.cart = cartData;
          this.fetchSellingPlans();
          this.checkIfFreeGiftShouldBeRemoved();
        } else {
          // Fallback to cart.js if section method fails
          const fallbackResponse = await fetch('/cart.js');
          const fallbackData = await fallbackResponse.json();
          this.$store.cart.cart = fallbackData;
          this.fetchSellingPlans();
          this.checkIfFreeGiftShouldBeRemoved();
        }
        
      } catch (error) {
        console.error('Error fetching cart with section:', error);
        // Final fallback to simple cart.js
        try {
          const response = await fetch('/cart.js');
          const data = await response.json();
          this.$store.cart.cart = data;
          this.fetchSellingPlans();
          this.checkIfFreeGiftShouldBeRemoved();
        } catch (fallbackError) {
          console.error('Error with fallback cart fetch:', fallbackError);
        }
      } finally {
        this.loading = false;
      }
    },
    
    async updateItemQuantity(key, quantity) {
      quantity = parseInt(quantity);
      
      // Show immediate feedback by updating the local data first
      const itemIndex = this.$store.cart.items.findIndex(item => item.key === key);
      if (itemIndex !== -1) {
        if (quantity <= 0) {
          // Visually remove item from cart immediately
          this.$store.cart.items.splice(itemIndex, 1);
          if (this.$store.cart.items.length === 0) {
            this.$store.cart.item_count = 0;
          }
        } else {
          // Update the item quantity locally
          const oldQuantity = this.$store.cart.items[itemIndex].quantity;
          this.$store.cart.items[itemIndex].quantity = quantity;
          this.$store.cart.item_count = this.$store.cart.item_count - oldQuantity + quantity;
        }
      }
      
      // Then send the update to the server
      try {
        this.loading = true;
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        
        // Update with the server response to ensure accuracy
        //this.$store.cart.cart = await response.json();
        //this.loading = false;

        this.fetchCart();

        //this.checkIfFreeGiftShouldBeRemoved();
        //window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: this.$store.cart.cart } }));
      } catch (error) {
        console.error('Error updating item quantity:', error);
        // If there was an error, refresh the cart to ensure data is correct
        this.fetchCart();
      }
    },
    
    async removeItem(key) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        
        this.fetchCart();

        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: this.$store.cart.cart } }));
      } catch (error) {
        console.error('Error removing item:', error);
      }

      return true;
    },
    
    upgradeToSubscription(itemKey, selectedPlanId, quantity) {
      this.loading = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: parseInt(selectedPlanId),
          quantity: quantity
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() =>{
        this.loading = false;
      })
    },
    
    formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: window.sideCart.currencyIsoCode
      });
    },
    
    fetchSellingPlans() {
      fetch('/?section_id=cart-selling-plans')
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const jsonScript = tempDiv.querySelector('#cart-selling-plans-data');
          if (jsonScript) {
            this.cartSellingPlans = JSON.parse(jsonScript.textContent);
          }
        });
    },

    addFreeGiftToCart(variantId){
      // Only used for backwards compatibility or manual selection
      if (variantId) {
        this.addToCart(variantId, {'_widget': 'cart9202689gqp'});
      }
    },

    checkIfFreeGiftShouldBeRemoved(){
      console.log('this.isFreeGiftInCart', this.isFreeGiftInCart);
      // Reset free gift removal flag if cart is empty
      if (this.$store.cart.cart.item_count === 0 && this.isFreeGiftManuallyRemoved) {
        this.updateCartAttributes({ free_gift_removed: null });
        return;
      }

      // Note: We no longer auto-add free gifts, user must select one
      // Just check if we need to remove it when threshold is not met
      if (!this.isFreeGiftEligible && this.isFreeGiftInCart) {
        // If the free gift is in the cart but not eligible, remove it and clear the manual removal flag
        const freeGiftItem = this.$store.cart.cart.items.find(item => 
          item.properties && 
          item.properties._widget === 'cart9202689gqp'
        );
        
        this.removeItem(freeGiftItem.key);
        // Clear the manual removal flag when automatically removing due to threshold
        this.updateCartAttributes({ free_gift_removed: null });
      }
    },

    async removeFreeGiftManually() {
      const freeGiftItem = this.$store.cart.cart.items.find(item => 
        item.properties && 
        item.properties._widget === 'cart9202689gqp'
      );

      if (freeGiftItem) {
        // Set cart attribute to prevent auto-adding
        await this.updateCartAttributes({ free_gift_removed: 'true' });
        // Remove the item
        await this.removeItem(freeGiftItem.key);
      }
    },

    async addFreeGiftBack() {
      // Clear the manual removal flag  
      await this.updateCartAttributes({ free_gift_removed: null });
      // Note: User will need to select a gift manually, we don't auto-add anymore
    },

    async updateCartAttributes(attributes) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ attributes: attributes })
        });
        
        const updatedCart = await response.json();
        this.$store.cart.cart = updatedCart;
      } catch (error) {
        console.error('Error updating cart attributes:', error);
      }
    },

    addToCart(variantId, properties) {
      this.loading = true;

      let cartItems = [{
        id: variantId,
        quantity: 1
      }];

      if (properties) {
        cartItems[0].properties = properties;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));
  

  function initCartSlider(container, paddingRight){
    const paddingRightMobile = paddingRight / 2
    new Splide('#splide-' + container, {
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: true,
      rewind: false,
      gap: '.9rem',
      padding    : {
        right   : paddingRight + 'rem',
        left    : '1rem',
      },
      breakpoints: {
        1024: {
          perPage: 1,
          gap: '1.13rem',
        },
        640: {
          perPage: 1,
          padding    : {
            right   : paddingRightMobile + 'rem',
            left    : '1rem',
          },
          gap: '1.12rem',
        },
      }
    }).mount();
  }

  Alpine.data('productRecommendations', () => ({
    recommendations: [],
    products: window.recommendedProducts || [],
    init() {
      //this.fetchRecommendations();

      this.$nextTick(() => {
        initCartSlider('recommendations', 8);
      });
    },

    fetchRecommendations() {
      // Get the first product from the cart store
      if (this.$store.cart.cart.items.length === 0) {
        return;
      }

      const firstProduct = this.$store.cart.cart.items[0];

      fetch('/recommendations/products?section_id=recommendations&product_id=' + firstProduct.product_id+ '&limit=4')
        .then(response => response.text())
        .then(async (responseHTML) => {
          //this.recommendations = data.products;
          //console.log('Data', data);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseHTML;
          const recommendationsContainer = tempDiv.querySelector('#shopify-section-recommendations');
          if (recommendationsContainer) {
            document.querySelector('#product-recommendation-container').innerHTML = recommendationsContainer.innerHTML;

            this.$nextTick(() => {
              initCartSlider('recommendations', 8);
            });
          }

        })
        .catch(error => console.error('Error fetching recommendations:', error));
    },
    addToCart(id){
      this.loading = true;

      let cartItems = [{
        id: id,
        quantity: 1
      }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
        // Emit cart:refresh
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));

  Alpine.data('freeSampleProducts', () => ({
    products: window.freeSampleProducts,

    init(){
      this.$nextTick(() => {
        initCartSlider('freesamples', 14);
      });
    },

    get freeSamplesInCart(){
      // Counts free sample products in the cart by comparing product IDs
      return this.$store.cart.cart.items
        .filter(cartItem => {
          // We need to check if any of the free sample products is in the cart
          return this.products.some(sampleProduct => {
            // Compare product IDs or variant IDs depending on what's available
            const sampleVariantId = sampleProduct.variants?.[0]?.id || sampleProduct.id;
            return cartItem.variant_id === sampleVariantId || cartItem.product_id === sampleProduct.id;
          });
        })
        .length;
    },

    addToCart(id){
      this.loading = true;

      let cartItems = [{
        id: id,
        quantity: 1
      }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems
        })
      })
      .then(res => res.json())
      .then(() => {
        this.fetchCart();
      })
      .finally(() => {
        this.loading = false;
        // Emit cart:refresh
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => console.error('Error adding free gift:', error));
    }
  }));
});

function initGWPSlider(){
    const gwpSlider = document.querySelector('#splide-gwp');
    if (gwpSlider) {
      new Splide('#splide-gwp', {
        perPage: 2,
        perMove: 2,
        pagination: false,
        arrows: false,
        gap: '0.5rem'
      }).mount();
    }
}

// DOM loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if there are any URL parameters indicating cart should be opened
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    window.dispatchEvent(new CustomEvent('cart:open'));
  }

  initGWPSlider();
});